<template>
  <v-toolbar
    flat
    dark
    max-height="56"
    color="secondary"
  >
    <v-btn
      icon
      color="primary"
      @click.stop="close()"
    >
      <v-icon v-text="icons.close" />
    </v-btn>
    <v-spacer />
    <v-toolbar-title v-text="title" />
    <v-spacer />
    <h-date-picker v-if="can('editOlderOrders')" />
    <h-search />
  </v-toolbar>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import NeedsPermission from '@/Mixins/NeedsPermission'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HDatePicker from './Actions/DatePicker'
  import HSearch from './Actions/Search'

  export default {
    mixins: [
      NeedsPermission,
      UsesIcons,
    ],

    components: {
      HDatePicker,
      HSearch,
    },

    computed: {
      ...mapState('history', [
        'date',
      ]),
      title () {
        return this.date?.format('L')
      },
    },

    methods: {
      ...mapActions('history', [
        'close',
      ]),
    },
  }
</script>
